import { columnTypes } from '@/services/Grid/ColumnTypes';

export const jobPropertyGridColumnTypes = columnTypes;

export const jobPropertyGridDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
  filterParams: {
    selectAllOnMiniFilter: false,
  },
};

export const jobPropertyGridColumns = [
  {
    headerName: 'ID',
    field: 'propertyId',
    width: 100,
    minWidth: 100,
    filter: 'agSetColumnFilter',
    sort: 'asc',
  },
  {
    headerName: 'UPRN',
    field: 'uprn',
    width: 180,
    minWidth: 180,
    filter: 'agSetColumnFilter',
  },
  {
    headerName: 'Property Status',
    field: 'propertyStatus',
    width: 180,
    minWidth: 180,
  },
  {
    headerName: 'RA Job Status',
    field: 'assessmentStatus',
    width: 180,
    minWidth: 180,
  },
  {
    headerName: 'Prop Class',
    field: 'riskProfileForPremise',
    width: 180,
    minWidth: 180,
  },
  {
    headerName: 'RH Prop Desg',
    field: 'propertyDesignation',
    width: 200,
    minWidth: 200,
  },
  {
    headerName: 'No Range',
    field: 'numberRange',
    width: 120,
    minWidth: 120,
  },
  {
    headerName: 'Building Name',
    field: 'buildingName',
    width: 200,
    minWidth: 200,
  },
  {
    headerName: 'Unit Number',
    field: 'unitNumber',
    width: 120,
    minWidth: 120,
  },
  {
    headerName: 'Street No',
    field: 'streetNumber',
    width: 120,
    minWidth: 120,
  },
  {
    headerName: 'Street',
    field: 'street',
    width: 200,
    minWidth: 200,
  },
  {
    headerName: 'Town',
    field: 'town',
    width: 200,
    minWidth: 200,
  },
  {
    headerName: 'Pcode',
    field: 'postcode',
    filter: 'agTextColumnFilter',
    width: 120,
    minWidth: 120,
  },
  {
    headerName: 'Client Prop Desg',
    field: 'clientPropertyDesignation',
    width: 200,
    minWidth: 200,
  },
  {
    headerName: 'No Storeys',
    field: 'numStoreys',
    width: 120,
    minWidth: 120,
  },
  {
    headerName: 'No Flats',
    field: 'totalNumFlatBesiteBedroom',
    width: 120,
    minWidth: 120,
  },
  {
    headerName: 'Prop Type',
    field: 'propertyType',
    width: 200,
    minWidth: 200,
  },
  {
    headerName: 'RA Expiry Date',
    field: 'dueDate',
    width: 120,
    minWidth: 120,
    type: 'dateColumn',
  },
  {
    headerName: 'RA POW',
    field: 'programDueDate',
    width: 120,
    minWidth: 120,
    type: 'dateColumn',
  },
  {
    headerName: 'Hand In Date',
    field: 'handoverDate',
    width: 140,
    minWidth: 140,
    type: 'dateColumn',
  },
];
